import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Hub, Project } from '@bimone/bimtrack-core';
import { EntitiesState } from '../types';

const initialState: EntitiesState = {
  hubs: undefined,
  projects: undefined,
};

const entitiesSlice = createSlice({
  name: 'entities',
  initialState,
  reducers: {
    updateHubs: (state, action: PayloadAction<Hub[] | undefined>): void => {
      state.hubs = action.payload;
    },
    updateProjects: (state, action: PayloadAction<Project[] | undefined>): void => {
      state.projects = action.payload;
    },
  },
});

export default entitiesSlice.reducer;

export const { updateHubs, updateProjects } = entitiesSlice.actions;
